import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { STATS } from "@/data";

const VALUES = [
  { t: "Craft", d: "We sweat the details others skip — because reliability lives in the details." },
  { t: "Ownership", d: "We act like founders of your product, not contractors passing through." },
  { t: "Velocity", d: "Small, senior teams that move fast without breaking what matters." },
  { t: "Transparency", d: "Clear communication, honest timelines, no black boxes." },
];

export default function About() {
  return (
    <>
      <PageHeader
        eyebrow="About Bluevera"
        title="A studio for serious software"
        subtitle="Bluevera IT Solutions is a technology studio helping startups and enterprises design, build and scale the systems that run their business. We combine product thinking, deep engineering and reliable cloud operations under one roof."
      />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="rounded-3xl overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1572021335469-31706a17aaef?w=1600&q=80"
            alt="The Bluevera team"
            className="w-full h-[280px] sm:h-[460px] object-cover"
          />
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-2 gap-16">
        <Reveal>
          <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight text-white">
            We turn ambitious ideas into dependable technology.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="space-y-6 text-zinc-400 text-lg leading-relaxed">
            <p>
              Founded on a simple belief — that good software should feel invisible — we partner with teams who care as much about the outcome as we do.
            </p>
            <p>
              From MVPs that need to prove a market, to enterprise platforms serving millions, our engineers, designers and cloud specialists ship work that stands up in production.
            </p>
          </div>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="border-t border-white/10 pt-5">
                <p className="font-display font-black text-4xl sm:text-5xl text-white">{s.value}</p>
                <p className="mt-2 text-sm text-zinc-500">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <p className="font-mono-j text-xs tracking-[0.2em] uppercase text-cyan-400 mb-10">What we value</p>
        <div className="grid md:grid-cols-2 gap-6">
          {VALUES.map((v, i) => (
            <Reveal key={v.t} delay={i * 0.08}>
              <div className="p-8 rounded-2xl border border-white/10 bg-[#0A0A0A]">
                <h3 className="font-display font-semibold text-2xl text-white">{v.t}</h3>
                <p className="mt-3 text-zinc-400">{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
